export function nullThrows<T>(
  value: T | null | undefined,
  message?: string,
): T {
  if (value === null || value === undefined) {
    throw new Error(message || 'Value is null or undefined');
  }
  return value;
}

export function assertTruthy<T>(value: T, message?: string): asserts value {
  if (!value) {
    throw new Error(message || 'Assertion failed');
  }
}

export function assertEqual<T>(a: T, b: T, message?: string): void {
  if (a !== b) {
    throw new Error(message || 'Values are not equal');
  }
}

export function sortByKey<T>(
  arr: Array<T>,
  key: (x: T) => Date | string | number,
  reverse = false,
) {
  const one = reverse ? 1 : -1;
  arr.sort((a, b) => {
    const ka = key(a);
    const kb = key(b);
    if (ka < kb) {
      return one;
    } else if (ka == kb) {
      return 0;
    } else {
      return -one;
    }
  });
}

export function replaceUnderscoreBySpace(text: string) {
  return text.replace(/_/g, ' ');
}
